// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__JC51X","footer":"ReportModalFilter_footer__25kRh"};